import React, {useState} from "react";
import ObjectivesCascadeList from "../../../objective/ObjectivesCascade/ObjectivesCascadeList";
import {getImage, getWeatherImage, sliceText} from "../../../../utils/utils";
import accountSVG from "../../../../images/account.svg";
import styled, {css} from "styled-components";
import Tooltip from "../../../tooltip/Tooltip";
import startIcon from "../../../../images/project/start.svg";
import {getDateInFrench, getDateInFrench2} from "../../../../utils/dateUtils";
import endIcon from "../../../../images/project/end.svg";
import update from "../../../../images/update.svg";
import confidentialSVG from "../../../../images/project/confidential.svg";
import {LinearProgressBar} from "../../../progress-bar/LinearProgressBar";
import ActionsCascadeList from "../../../action/ActionsCascade/ActionsCascadeList";
import {DisplayForPilotAndCopilot} from "../../../../permissions/DisplayAccordingToRole";
import {IS_SPONSOR} from "../../../../permissions/roleTypes";
import {useDispatch, useSelector} from "react-redux";
import YesNoModal from "../../../modal/YesNoModal";
import {deleteOneProject} from "../../one-project/projectAction";
import {CLEAR_PROJECT} from "../../actionsType";
import {loadProjects} from "../projectsAction";
import {useNavigate} from "react-router-dom";
import SubTagPlentyCard from "../../../tag/subTag/SubTagPlentyCard";

const ProjectCascadeCard = ({project, hideActions, users}) => {
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const [openObjective, setOpenObjective] = useState(false);
    const [openAction, setOpenAction] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const currentUser = useSelector((state) => state.currentUser);
    const members = users?.filter(user => user.projects.map(p => p.id).includes(project.id))
    const tagMembers = members?.filter(member => member.tags.length > 0);

    const pilot = project.pilot;
    const axisSponsor = project.axisSponsor;

    const getLateInfo = () => {
        const today = new Date();
        const lastUpdate = Date.parse(project.lastUpdate)
        const time = Math.abs(lastUpdate - today)
        const res = Math.ceil(time / (1000 * 60 * 60 * 24)) - 1
        if (res < 15) {
            return "upToDate"
        } else if (res > 30) {
            return "midLate"
        } else return ""
    }
    const displayModal = () => {
        if (isOpenDeleteModal) {
            return (<YesNoModal
                    name={"ce projet (vous pouvez le retrouver dans les archives) ?"}
                    setOpenModal={setIsOpenDeleteModal}
                    handleClickYesAction={deleteRequest}
                    id={project.id}
                />)
        }
    }

    const loadProjectHandler = () => {
        if (currentUser.status === 200) {
            navigate(`/projets/${project.id}`);
        }
    };

    const gotToGuidedUpdate = async () => {
        navigate(`/maj-projet/${project.id}`)
    }

    const deleteRequest = async (project_id) => {
        if (currentUser.status === 200) {
            await dispatch(deleteOneProject(project_id))
            setIsOpenDeleteModal(false);
            dispatch({type: CLEAR_PROJECT})
            await dispatch(loadProjects(currentUser.id))
        }
    }

    const handleOpenChildren = () => {
        setOpenObjective(!openObjective);
        setOpenAction(!openAction);
    };

    const displayWeather = () => {
        if (project.weather === "sunny" || project.weather === "cloudy") {
            return (<WeatherContainer>
                    <Tooltip content={sliceText(project.success, 100)} data-html={"true"}>
                        <WeatherIcon
                            src={getWeatherImage(project.weather)}
                            alt="icone météo"
                        />
                    </Tooltip>
                </WeatherContainer>);
        }

        if (project.weather === "stormy" || project.weather === "rainy") {
            return (<WeatherContainer>
                    <Tooltip content={sliceText(project.difficulties, 100)}>
                        <WeatherIcon
                            src={getWeatherImage(project.weather)}
                            alt="icone météo"
                        />
                    </Tooltip>
                </WeatherContainer>);
        } else {
            return (<WeatherContainer>
                    <Tooltip content="Météo non renseignée">
                        <WeatherIcon
                            src={getWeatherImage(project.weather)}
                            alt="icone météo"
                        />
                    </Tooltip>
                </WeatherContainer>);
        }
    };
    return (<>
            <Container>
                <Card onClick={handleOpenChildren}>
                    <div className={'flex-row ai-center gap-05'}>
                        <PilotPicture src={getImage(pilot.photo, accountSVG)} alt="pilote"/>
                        <p> {pilot.firstName === "Deleted" ? "Utilisateur supprimé" : pilot.firstName} {pilot.lastName === "User" ? "" : pilot.lastName} </p>
                    </div>
                    <FlexColumn>
                        <Tooltip content={project.name} type={"projectName"}>
                            <Title> {project.name} </Title>
                        </Tooltip>

                        <DateContainer>
                            <Dates>
                                <Tooltip content={"Date de début du projet"}>
                                    <img src={startIcon} alt="date de début de projet"/>
                                    <p> {project.startDate === null ? "Non défini" : getDateInFrench2(project.startDate)} </p>
                                </Tooltip>

                            </Dates>
                            <Dates>
                                <Tooltip content={"Date de fin du projet"}>
                                    <img src={endIcon} alt={"date de fin de projet"}/>
                                    <p> {project.endDate === null ? "Non défini" : getDateInFrench2(project.endDate)} </p>
                                </Tooltip>
                            </Dates>
                            <Tooltip content={"Date de dernière mise à jour du projet"}>
                                <Dates>
                                    <img src={update} alt={"date de dernière mise à jour"}/>
                                    <p className={'guided-update-link'}> {project.lastUpdate === null ? "Non défini" : getDateInFrench(project.lastUpdate)} </p>
                                </Dates>
                            </Tooltip>
                        </DateContainer>
                    </FlexColumn>
                    {displayWeather()}
                    <LinearProgressBarContainer justifyContent={project.confidential ? "unset" : ""}>
                        {project.confidential && <ConfidentialDiv>
                            <Tooltip content={"Confidentiel"}>
                                <img src={confidentialSVG} alt={"confidentiel"} className={"confidential-svg"}/>
                            </Tooltip>
                            <p> Projet confidentiel</p>
                        </ConfidentialDiv>}
                        {LinearProgressBar(project.advancement)}
                    </LinearProgressBarContainer>
                    <TagSection>
                        <div className={"wrapper"}>
                            {tagMembers ?
                                <>
                                    <p style={{fontSize: "12px"}}> {tagMembers[0]?.firstName} {tagMembers[0]?.lastName}</p>
                                    {tagMembers[0]?.tags.map(tag => (
                                        <SubTagPlentyCard
                                            key={tag.id + tag.name}
                                            color={tag.color}
                                            id={tag.id}
                                            name={tag.name}
                                            className={"no-hover"}
                                            height={"12px"}
                                        />
                                    ))}
                                </>
                                :
                                null
                            }
                            {project.tags.map(tag => (<SubTagPlentyCard
                                    key={tag.id + tag.name}
                                    color={tag.color}
                                    id={tag.id}
                                    category={tag.category}
                                    name={tag.name}
                                    className={"no-hover"}
                                />))}
                        </div>

                    </TagSection>
                </Card>
                {
                    !hideActions &&
                    <ButtonsContainer>
                        <>
                            <PitchProjectButton
                                onClick={loadProjectHandler}
                            >
                                Pitch projet
                            </PitchProjectButton>
                            <DisplayForPilotAndCopilot
                                pilot={pilot}
                                copilot={project.coPilot}
                                hasException={IS_SPONSOR(currentUser.id, axisSponsor)}
                                component={<UpdateProjectButton
                                    $mode={getLateInfo()}
                                    onClick={gotToGuidedUpdate}
                                >
                                    Mettre à jour
                                </UpdateProjectButton>}
                            />
                        </>
                    </ButtonsContainer>
                }
            </Container>
            {displayModal()}
            {openObjective && openAction && <>
                <ObjectivesCascadeList
                    objectives={project.okrs}
                    fromProject={true}
                />
                <ActionsCascadeList
                    actions={project.actions}
                    fromProject={true}
                />
            </>}

        </>)
}

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  @media (min-width: 1000px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: 1000px) {
    flex-direction: row;
    justify-content: center;
  }
  @media print {
    page-break-inside: avoid;
    flex-direction: row;
    min-width: 100%;
  }
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background: var(--color-grey-03);
  }

  p {
    text-align: center;
    font-size: 13px;
  }

  .advancement-div {
    display: flex;
    flex-direction: column;
    align-items: center;

    .progress-container {
      height: 0.6rem;
      width: 10rem;
      border-radius: 0.4rem;
      background: var(--color-grey-06);
      -webkit-tap-highlight-color: transparent;
    }
  }

  @media (min-width: 768px) {
    height: 100%;
  }
  @media (min-width: 1000px) {
    width: 90%;
    height: unset;
    min-height: 6rem;
    display: inline-grid;
    gap: 1rem;
    padding: 0.5rem 1rem ;
    grid-template-columns: 15% 50% 10% 20%;
    p {
      text-align: start;
    }

    .advancement-div {
      display: flex;
      flex-direction: column;
      align-items: center;

      .progress-container {
        width: 9rem;
      }
    }
  }

  @media print {
    min-width: 100%;
    height: unset;
    min-height: 6rem;
    display: inline-grid;
    gap: 1rem;
    padding: 0.5rem 1rem;
    grid-template-columns: 15% 55% 5% 15%;
    box-shadow: none;
    p {
      text-align: start;
    }

    .advancement-div {
      display: flex;
      flex-direction: column;
      align-items: center;

      .progress-container {
        width: 8rem;
      }
    }
  }
`
const PitchProjectButton = styled.button`
  padding: 0.5rem;
  border: none;
  background-color: var(--color-blue);
  color: white;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 0.5rem;
`

const UpdateProjectButton = styled.button`

  padding: 0.5rem;
  border: none;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 0.5rem;
  ${(props) => {
    switch (props.$mode) {
      case "upToDate":
        return css`
          background-color: var(--color-green);
        `
      case "midLate":
        return css`
          background-color: var(--color-yellow);
        `
      case "highLate":
        return css`
          background-color: var(--color-red);
        `
      default:
        return css`
          color: black;
        `;
    }
  }}
`;
const TagSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 0 1rem;
  width: 100%;
  grid-column: 1/5;

  .wrapper {
    display: flex;
    flex-direction: row;
    margin: 0 0.5em;
    width: 100%;
    gap: 0.5rem;
    padding: 0.3rem;
    overflow-x: auto;
  }

  @media print {
    display: none;
  }
`;
const Title = styled.h5`
  text-align: center;
  padding-bottom: 0.5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80%;
  font-size: 14px;
`
const PilotPicture = styled.img`
  width: 3em;
  height: 3em;
  border-radius: 50%;
  object-fit: cover;
  @media (min-width: 768px) {
    width: 3.5em;
    height: 3.5em;
  }
`;
const WeatherContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const WeatherIcon = styled.img`
  width: 3rem;
  margin-bottom: 1em;
  cursor: pointer;
  @media (min-width: 850px) {
    margin-bottom: 0;
  }
  @media print {
    width: 2rem;
    margin-bottom: 0;
  }
`;
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 1rem;
`;
const DateContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 0.5rem;
  width: 80%;
  @media (min-width: 1000px) {
    padding-top: 0.5em;
    display: inline-grid;
    grid-template-columns: repeat(3, 30%);
    width: 100%;
    justify-content: center;
  }
  @media print {
    padding-top: 0.5em;
    display: inline-grid;
    grid-template-columns: repeat(3, 30%);
    width: 100%;
    justify-content: center;
  }
`
const Dates = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  img {
    margin-right: 2px;
  }
`;

const LinearProgressBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: ${(props) => props.justifyContent || "center"};
  height: 100%;

  p {
    font-weight: 700;
  }

  @media (min-width: 768px) {
    height: 100%;

  }
  @media (min-width: 1000px) {
    align-items: flex-start;
  }
`;
const ConfidentialDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  @media (min-width: 768px) {
    .confidential-svg {
      align-self: flex-end;
      width: 100%;
    }
  }
  @media (min-width: 1000px) {
    p {
      display: none;
    }
  }
  @media print {
    p {
      display: none;
    }
  }
`;

export default ProjectCascadeCard;